import axios from "axios";
import React, { useState, useEffect } from "react";
import CreaEquipoMejoramiento from "./Equipos/CreaModals/CreaEquipoMejoramiento";
import Cookies from "universal-cookie";

function Titulo2SeccionF(props) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);

  const obtenerEquipos = () => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoMejoramientoPorSolicitudId?SolicitudId=" +
        props.idSolicitud,
    })
      .then((response) => {
        setList(response.data);
      })
      .catch((error) => {
        console.error("Error al obtener equipos:", error);
      });
  };

  useEffect(() => {
    obtenerEquipos();
  }, [props.idSolicitud]);

  const eliminarEquipo = (id) => {
    const confirmar = window.confirm(
      "¿Está seguro de que desea eliminar este integrante del equipo?",
    );
    if (!confirmar) return;

    axios({
      method: "delete",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: `https://suadesarrollo.azurewebsites.net/api/eliminarEquipoMejoramientoPorId?Id=${id}`,
      data: {
        tipoAccion: "Eliminación de registro en equipo tecnologia",
        idUsuario: cookies.get("id"),
      },
    })
      .then((response) => {
        alert("Integrante eliminado correctamente.");
        obtenerEquipos();
      })
      .catch((error) => {
        console.error("Error al eliminar equipo:", error);
        alert("Error al eliminar el integrante.");
      });
  };

  const url = window.location.href;
  const partesURL = url.split("/");
  const nombreRuta = partesURL[partesURL.indexOf("#") + 1];

  return (
    <div className="test">
      <div className="container">
        <div className="text-center">
          <div className="container-fluid">
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold text-primary">
                  1. EQUIPO DE MEJORAMIENTO INSTITUCIONAL
                </h6>
              </div>
              <div className="card-body">
                {cookies.get("tipo_Usuario") == 2 &&
                nombreRuta == "ProcesoAutoevaluacion" ? (
                  <CreaEquipoMejoramiento idSolicitud={props.idSolicitud} />
                ) : null}

                <div className="table-responsive mt-3">
                  <table
                    className="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellSpacing="0"
                  >
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Nombre</th>
                        <th>Servicio</th>
                        <th>Cargo</th>
                        <th>SolicitudId</th>
                        {nombreRuta == "ProcesoAutoevaluacion" ? (
                          <th>Elimina</th>
                        ) : (
                          <h></h>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {list.map((item) => (
                        <tr key={item.id}>
                          <td>{item.id}</td>
                          <td>{item.nombre}</td>
                          <td>{item.servicio}</td>
                          <td>{item.cargo}</td>
                          <td>{item.solicitudId}</td>
                          {nombreRuta == "ProcesoAutoevaluacion" ? (
                            <td>
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() => eliminarEquipo(item.id)}
                              >
                                Eliminar
                              </button>
                            </td>
                          ) : (
                            <j></j>
                          )}
                        </tr>
                      ))}
                      {list.length === 0 && (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No hay registros disponibles.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Titulo2SeccionF;
